import i18n from "i18next";
import type { FC } from "react";
import { useLocation, useNavigate } from "react-router";

import { SecondaryButton } from "../../../../../components/Buttons/components/ActionButton";
import { ResourceName, ResourceVariant } from "../../../../../core/router/config/ResourceName";
import { withReturnTo } from "../../../../../core/router/navigation/returnTo";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import type { ID } from "../../../../../core/types/fe";

export interface AddVirtualButtonProps {
    siteId?: ID;
}

export const AddVirtualButton: FC<AddVirtualButtonProps> = ({ siteId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const onClick = () =>
        navigate(
            `${BASE_PATH}/${ResourceName.CONTRACTS}/${ResourceVariant.VIRTUAL}/${FORM_ACTION.CREATE}?discriminator=VIRTUAL&service=true${
                siteId ? `&siteId=${siteId}` : ""
            }`,
            withReturnTo(location),
        );

    return (
        <SecondaryButton onClick={onClick} disabled={false}>
            {i18n.t("contract.add.virtual")}
        </SecondaryButton>
    );
};
